"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUrlPagination = void 0;
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var useUrlPagination = function () {
    var _a = (0, react_router_dom_1.useSearchParams)(), searchParams = _a[0], setSearchParams = _a[1];
    var page = parseInt(searchParams.get("page") || "1", 10);
    var pageSize = parseInt(searchParams.get("pageSize") || "10", 10);
    var onChange = (0, react_1.useCallback)(function (page_, pageSize_) {
        setSearchParams({ page: page_, pageSize: pageSize_ });
    }, []);
    return { current: page, pageSize: pageSize, onChange: onChange, size: "default" };
};
exports.useUrlPagination = useUrlPagination;
